<template>
  <div
    ref="containerRef"
    class="col-start-2 col-span-12 flex flex-col relative cursor-pointer lg:hidden"
  >
    <div
      class="w-[2px] bg-typography h-[calc(100%-40px)] top-[30px] left-[9px] absolute"
    ></div>
    <div class="relative flex items-center pb-8">
      <div class="l w-5 h-5 flex justify-center items-center">
        <div class="w-2 h-2 bg-typography rounded-full" />
      </div>
      <header4
        :key="year"
        :text="year"
        classes="ml-[22px]"
        :is-umbraco="isUmbraco"
        :theme="themeType"
      />
    </div>

    <div class="h-auto overflow-hidden ml-10" ref="innerRef">
      <div>
        <header1
          :key="title"
          :text="title"
          classes="pb-5"
          :is-umbraco="isUmbraco"
          :theme="themeType"
        />
        <rich-text
          :text="content"
          classes="pb-8"
          :is-umbraco="isUmbraco"
          :theme="themeType"
        />

        <image-component
          :img-alt="title"
          :image="image"
          :list="false"
          loading="eager"
          classes="w-full h-full pb-20"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ITimelineYear } from "@/types/components/ITimeLineProps";
import { toRefs } from "vue";
import Header4 from "@components/Typography/Header4.ce.vue";
import Header1 from "@components/Typography/Header1.ce.vue";
import RichText from "@components/Typography/RichText.ce.vue";
import ImageComponent from "@atoms/Image/Img.vue";

interface YearProps extends ITimelineYear {
  isUmbraco?: boolean;
  themeType: "dark" | "light";
}

const props = withDefaults(defineProps<YearProps>(), {
  isUmbraco: false,
});

const { isUmbraco, year, title, content, image, themeType } = toRefs(props);
</script>
